import { expVal } from '@atlassian/jira-feature-experiments';
import { applyObservabilityHeaders } from '@atlassian/jira-fetch/src/utils/observability-headers.tsx';

export const getBacklog = (
	planId: string | null | undefined,
	scenarioId: string | null | undefined,
): Promise<Response> => {
	const planIdNum = Number.parseFloat(planId || 'NaN');
	const scenarioIdNum = Number.parseFloat(scenarioId || 'NaN');
	if (Number.isNaN(planIdNum)) {
		throw new Error('Plan cannot be loaded without a planId');
	}
	if (Number.isNaN(scenarioIdNum)) {
		throw new Error('Plan cannot be loaded without a scenarioId');
	}

	const backlogRequestBody = {
		planId: planIdNum,
		scenarioId: scenarioIdNum,
		filter: {
			includeCompleted: true,
			includeIssueLinks: true,
		},
		supportingDataOptions: {
			assignees: true,
			reporters: true,
			externalTeams: true,
			sprints: true,
			rollups: true,
		},
	};

	const url = '/rest/jpo/1.0/backlog/compact?operation=getBacklogCompact';

	const options = {
		method: 'POST',
		body: JSON.stringify(backlogRequestBody),
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	};

	return fetch(
		url,
		expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)
			? applyObservabilityHeaders(url, options)
			: options,
	);
};
